import { Box, Button, Group, MultiSelect } from '@mantine/core';
import { IconFilterCancel } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';

const SiteProviderFilter = ({ providers, onFilter }) => {
  const [selectedProviders, setSelectedProviders] = useState([]);

  useEffect(() => {
    onFilter({ selectedProviders });
  }, [selectedProviders, onFilter]);

  const handleClear = () => {
    setSelectedProviders([]);
  };

  return (
    <Box pos="relative">
      <Group>
        <MultiSelect
          label="廠商"
          placeholder="全部"
          data={providers.map((v) => ({ value: v.id, label: v.name }))}
          value={selectedProviders}
          onChange={setSelectedProviders}
          searchable
          clearable
        />
      </Group>
      <Box pos="absolute" top={0} right={0}>
        <Button
          variant="outline"
          size="xs"
          onClick={handleClear}
          leftSection={<IconFilterCancel size={14} />}
        >
          清除篩選
        </Button>
      </Box>
    </Box>
  );
};

export default SiteProviderFilter;
